<ng-template vdrDialogTitle>
  <div class="dialog-header">
    <div class="dialog-title">
      {{ asset.name }}
    </div>
    <div class="btn-close" (click)="resolveWith()">
      <vdr-icon name="close"></vdr-icon>
    </div>
  </div>
</ng-template>

<vdr-asset-preview
  *ngIf="assetWithTags$ | async as assetWithTags"
  [asset]="assetWithTags"
  (assetChange)="assetChanges = $event"
  (editClick)="resolveWith()"
  [assets]="assetsWithTags$ | async"
></vdr-asset-preview>
